import { ListerProductData, BreadcrumbData, FacetData, Action } from '../../types';
import { ListerActionTypes } from './listerReducer';

function isSamePriceInAllResults(results: ListerProductData[]): boolean {
  if (results.length && results[0].price) {
    const price = results[0].price.value;
    return results.every((result) => result.price && result.price.value === price);
  }

  return true;
}

function isFacetApplied(breadcrumbs: BreadcrumbData[], code: string): boolean {
  return breadcrumbs.some((breadcrumb) => breadcrumb.facetCode.match(code));
}

function isPriceFacetVisible(results: ListerProductData[], breadcrumbs: BreadcrumbData[]): boolean {
  if (isFacetApplied(breadcrumbs, 'price')) {
    return true;
  }

  return !(results.length === 1 || isSamePriceInAllResults(results));
}

function filterFacets(action: Action<ListerActionTypes>): FacetData[] {
  const { facets, results, breadcrumbs } = action;

  if (!isPriceFacetVisible(results, breadcrumbs)) {
    const priceFacetIndex = facets.findIndex((facet) => facet.priceFacet);
    if (priceFacetIndex > -1) {
      facets.splice(priceFacetIndex, 1);
    }
  }

  return facets;
}

export default filterFacets;
